import { observer } from "mobx-react";
import React from "react";
import { IAgent } from "../../models/agent/Agent";
import { IGuest } from "../../models/base/Guest";
import { L10nHtml } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { getFriendlyDateString, getTimeString } from "@fidget/common/utils/timeFormatter";
import { ChatClosedLine } from "@fidget/common/components/chat/chatClosedLine";
import { ChatNotification } from "@fidget/common/components/mstchat/chatNotification";
import { ConversationStatus } from "@closerplatform/spinner-openapi";

interface Props {
  status: ConversationStatus;
  timestamp: number;
  user?: IAgent | IGuest;
  currentUser: IAgent | IGuest;
}

@observer
export class ChatStatusNotification extends React.Component<Props> {
  render() {
    const { status, user, timestamp } = this.props;
    let line;
    const agentName = (user && user.displayedName) || "empty";
    switch (status) {
      case "solved":
      case "unsolved":
        line = (
          <L10nHtml
            id={"conversation.event.closed"}
            values={{
              status: this.getConversationStatusLabel(status),
              name: agentName
            }}
          />
        );
        return (
          <>
            <ChatNotification message={line} />
            <ChatClosedLine
              time={getTimeString(timestamp)}
              status={status}
              date={getFriendlyDateString(timestamp)}
            />
          </>
        );
      case "inProgress":
        line = <L10nHtml id={"conversation.event.reopened"} values={{ name: agentName }} />;
        return <ChatNotification message={line} />;
      default:
        line = (
          <L10nHtml
            id={"conversation.event.statusChanged"}
            values={{ status: this.getConversationStatusLabel(status), name: agentName }}
          />
        );
        return <ChatNotification message={line} />;
    }
  }

  getConversationStatusLabel = (status: ConversationStatus): string => {
    switch (status) {
      case "waiting":
        return intl.formatMessage("conversation.status.waiting");
      case "solved":
        return intl.formatMessage("conversation.status.solved");
      case "unsolved":
        return intl.formatMessage("conversation.status.unsolved");
      default:
        throw new Error("unsupported conversation status: " + status);
    }
  };
}
